module.exports = __webpack_public_path__ + "img/protection.68790787.svg";